import React, {FunctionComponent} from 'react';
import {useRouteMatch} from 'react-router-dom';

import {isLoggedIn} from '../../utils/auth';
import {ExecutionFiltersContainer} from './ExecutionFilters';
import {GlobalSettingsTab} from './GlobalSettingsTab';
import {useCurrentUser} from "../../hooks";

import './GlobalLeftMenu.scss';

interface GlobalLeftMenuProps {
}

export const GlobalLeftMenu: FunctionComponent<GlobalLeftMenuProps> = ({}: GlobalLeftMenuProps) => {
  const currentUser = useCurrentUser();

  const adminMatch = useRouteMatch('/a/*');

  const isAdmin = (adminMatch?.isExact && !adminMatch?.url.startsWith('/a/log')) || false;
  const isExecutionHistory = (adminMatch?.isExact && adminMatch?.url.startsWith('/a/log')) || false;

  return (
    <div className="global-menu__tabs">
      {isLoggedIn(currentUser) && isAdmin && <GlobalSettingsTab/>}
      {isLoggedIn(currentUser) && isExecutionHistory && <ExecutionFiltersContainer/>}
    </div>
  );
};
